var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPizza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4900C",
    d: "M18 4c7.257 0 13 4 14.699 2 .197-.323.301-.657.301-1 0-2-6.716-5-15-5C9.716 0 3 3 3 5c0 .343.104.677.301 1C5 8 10.743 4 18 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    d: "M18 3C11.787 3 7.384 4.81 5.727 5.618c-.477.233-.539.84-.415 1.278S16 34 16 34s.896 2 2 2 2-2 2-2L30.704 6.779s.213-.842-.569-1.229C28.392 4.689 24.047 3 18 3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BE1931"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 31c0-2.208-1.791-4-4-4-.254 0-.5.029-.741.075L16 34s.071.14.19.342C17.279 33.627 18 32.399 18 31zm-1-11c0-2.209-1.792-4-4-4-1.426 0-2.67.752-3.378 1.876l2.362 5.978c.327.086.663.146 1.016.146 2.208 0 4-1.792 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 9c-2.208 0-4 1.791-4 4s1.792 4 4 4c.682 0 1.315-.187 1.877-.488l1.89-4.806C28.227 10.135 26.752 9 25 9zm-6 16c0 1.868 1.288 3.425 3.019 3.864l2.893-7.357C24.342 21.194 23.697 21 23 21c-2.208 0-4 1.792-4 4zm-9-13c0-2.209-1.791-4-4-4-.087 0-.169.02-.255.026.55 1.412 1.575 4.016 2.775 7.057C9.416 14.349 10 13.248 10 12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.ebc498ffa1fa3e06b9ea711c2ed081ca.svg";
export { ForwardRef as ReactComponent };